import { useContext, createContext, useState, useEffect } from "react";
import api from "../services/api";

const AppDataContext = createContext({
  api: null,
  notificationCount: 0,
  refreshNotificationCount: () => {},
});

export const AppDataContextProvider = ({ children }) => {
  const [notificationCount, setNotificationCount] = useState(0);
  const refreshNotificationCount = async () => {
    try {
      const result = await api.notification.getNotificationCount();
      setNotificationCount(result ?? 0);
    } catch (err) {
      console.error("Count fetch failed", err);
    }
  };

  useEffect(() => {
    refreshNotificationCount();
  }, []);

  const values = {
    api,
    notificationCount,
    refreshNotificationCount,
  };

  return (
    <AppDataContext.Provider value={values}>{children}</AppDataContext.Provider>
  );
};

export const useAppData = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    console.error("useAppData must be used within AppDataContextProvider");
    return { api: null };
  }
  return context;
};

export { AppDataContext };
